import React from 'react';
import '../styles/Footer.css';

import { sendContactEmail } from './DataHandler';

import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Footer = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const token = localStorage.getItem('token');
        setIsLoggedIn(!!token);
    }, [location]);
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section company-info">
                        <h3 className="footer-logo">i2r</h3>
                        <p>
                            IoT · Physical AI · On-Device AI · Data Science
                        </p>
                        <p className="address">
                            경기도 고양시 일산동구 동국로32 231호<br />
                            (식사동 동국대학교 산학협력단)
                        </p>
                    </div>
                    <div className="footer-section contact-form">
                        <h4>문의하기</h4>
                        <form onSubmit={async (e) => {
                            e.preventDefault();
                            const form = e.currentTarget;
                            const formData = new FormData(form);
                            const email = formData.get('email') as string;
                            const message = formData.get('message') as string;

                            try {
                                await sendContactEmail(email, message);
                                alert('메일이 성공적으로 전송되었습니다.');
                                form.reset();
                            } catch (error) {
                                alert('메일 전송에 실패했습니다.');
                                console.error(error);
                            }
                        }}>
                            <input type="email" name="email" placeholder="답변 받을 이메일" required />
                            <textarea name="message" placeholder="문의 내용" rows={3} required></textarea>
                            <button type="submit" className="btn btn-primary btn-sm">i2r에 전송</button>
                        </form>
                    </div>
                    <div className="footer-section links">
                        <h4>바로가기</h4>
                        <ul>
                            <li><Link to="/">홈</Link></li>
                            <li>
                                {isLoggedIn ? (
                                    <Link to="/overview">대시보드</Link>
                                ) : (
                                    <a href="/#dashboard-preview">대시보드</a>
                                )}
                            </li>
                            <li><a href="https://github.com/kdi6033" target="_blank" rel="noopener noreferrer">문서</a></li>
                            <li><Link to="/products">제품</Link></li>
                            <li><a href="https://www.youtube.com/@i2r-link" target="_blank" rel="noopener noreferrer">유튜브</a></li>
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} i2r IoT PLC & Sensor. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
